import { render, staticRenderFns } from "./modal-notice-view.vue?vue&type=template&id=77d1fce7&"
import script from "./modal-notice-view.vue?vue&type=script&lang=js&"
export * from "./modal-notice-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports